import type { ChangeEvent } from '@/lib/api/performance'
import type { BlockType } from '@/types/content-blocks'

export type HistoryBadge = 'created' | 'ai' | 'sync' | 'edited'

export interface HistoryRow {
  id: string
  track: 'content' | 'asset'
  badge: HistoryBadge
  blockType: BlockType | null
  slot: number | null
  scope: string
  channelId: string | null
  versionNumber: number | null
  timestamp: string
  summary: string | null
}

function badgeFor(ev: ChangeEvent): HistoryBadge {
  if (ev.version_number === 1) return 'created'
  switch (ev.source_type) {
    case 'regenerate':
      return 'ai'
    case 'manual_publish':
    case 'scheduled_restore':
    case 'rollback':
      return 'sync'
    default:
      return 'edited'
  }
}

export function changeEventToRow(
  ev: ChangeEvent,
  channelName: (id: string | null) => string,
): HistoryRow {
  return {
    id: ev.id,
    track: ev.event_type === 'image' ? 'asset' : 'content',
    badge: badgeFor(ev),
    blockType: (ev.block_type as BlockType | null) ?? null,
    slot: ev.slot,
    scope: channelName(ev.channel_id),
    channelId: ev.channel_id,
    versionNumber: ev.version_number,
    timestamp: ev.timestamp,
    summary: ev.diff_summary,
  }
}
